import { Component, Input, OnDestroy } from '@angular/core';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IAuthenticate } from 'src/app/models/auth/interfaces/authenticate.interface';
import { SettingsService } from 'src/app/services/settings.service';

import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.scss'],
    imports: [RouterLink, FaIconComponent]
})
export class UserProfileComponent implements OnDestroy {
    /**
     * Utilisé pour gérer la désincription des observables lorsque le composant est détruit.
     */
    protected componentDestroyed$: Subject<void> = new Subject<void>();

    public userProfileIcon = faUser;

    @Input()
    public userConnected: IAuthenticate;

    public displayProfile: boolean = false;

    public userManagerUrl: string;

    constructor(private settingsService: SettingsService) {
        this.settingsService
            .getSettings()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((result) => {
                this.userManagerUrl = result.apps.gum.url;
            });
    }

    /**
     * Appelée à la destruction du composant.
     */
    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
